import React, { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router-dom" 
import { callAPI } from "../components/utils" 
import { validatePassword } from "../components/utils"

const ResetPasswordPage = () => {
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [message, setMessage] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [loading, setLoading] = useState(false)
  const [token, setToken] = useState(null) 
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    setToken(params.get("token"))
  }, [location])

  const handleResetPassword = async (event) => {
    event.preventDefault()
    setLoading(true)
    setErrorMessage("")
    setMessage("")

    const passwordValidationError = validatePassword(newPassword)
    if (passwordValidationError) {
      setErrorMessage(passwordValidationError)
      setLoading(false)
      return
    }

    if (newPassword !== confirmPassword) {
      setErrorMessage("Passwords do not match.")
      setLoading(false)
      return
    }

    try {
      await callAPI({
        request: "resetPassword",
        method: "post",
        params: { token, newPassword },
        onSuccess: (data) => {
          setMessage("Your password has been reset successfully.")
          setTimeout(() => navigate("/login"), 2000)
        },
        onError: (error) => {
          setErrorMessage(error || "An unknown error occured while resetting the password. Please try again later.")
        },
      })
    } catch (error) {
      setErrorMessage("An error occurred while resetting the password.")
      console.error("Reset Password API Error:", error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="reset-password-container">
      <h2>Reset Password</h2>
      <form onSubmit={handleResetPassword}>
        <div>
          <label>New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Confirm New Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <div>
          <button type="submit" disabled={loading}>
            {loading ? <span className="spinner"></span> : "Reset Password"}
          </button>
        </div>
      </form>
      {message && <p className="success-message">{message}</p>}
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </div>
  )
}

export default ResetPasswordPage
